/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.10.8.0 (NJsonSchema v10.3.11.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';

import { ContactType, CustomerDto, CustomerEditDto, CustomerListDto, CustomerLocationDto, CustomerLocationEditDto } from './common-proxies';
import { API_BASE_URL, blobToText, throwException } from './proxy-helpers';
import { UploadFileInput, UserListDto } from './shared-models';

@Injectable()
export class CustomerServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param filter (optional)
     * @param name (optional)
     * @param customerId (optional)
     * @param partnerId (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     * @deprecated
     */
    getCustomers(
        filter: string | undefined,
        name: string | undefined,
        customerId: number | undefined,
        partnerId: number | undefined,
        sorting: string | undefined,
        maxResultCount: number | undefined,
        skipCount: number | undefined
    ): Observable<CustomerListDtoPagedResultDto> {
        let url_ = this.baseUrl + '/api/services/app/Customer/GetCustomers?';
        if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
        if (name === null) throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined) url_ += 'Name=' + encodeURIComponent('' + name) + '&';
        if (customerId === null) throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined) url_ += 'CustomerId=' + encodeURIComponent('' + customerId) + '&';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'PartnerId=' + encodeURIComponent('' + partnerId) + '&';
        if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCustomers(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCustomers(<any>response_);
                        } catch (e) {
                            return <Observable<CustomerListDtoPagedResultDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CustomerListDtoPagedResultDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCustomers(response: HttpResponseBase): Observable<CustomerListDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = CustomerListDtoPagedResultDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CustomerListDtoPagedResultDto>(<any>null);
    }

    /**
     * @param input (optional)
     * @param partnerId (optional)
     * @return Success
     * @deprecated
     */
    getCustomerList(input: string | undefined, partnerId: number | undefined): Observable<CustomerDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Customer/GetCustomerList?';
        if (input === null) throw new Error("The parameter 'input' cannot be null.");
        else if (input !== undefined) url_ += 'input=' + encodeURIComponent('' + input) + '&';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'partnerId=' + encodeURIComponent('' + partnerId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCustomerList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCustomerList(<any>response_);
                        } catch (e) {
                            return <Observable<CustomerDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CustomerDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCustomerList(response: HttpResponseBase): Observable<CustomerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(CustomerDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CustomerDto[]>([]);
    }

    /**
     * @param input (optional)
     * @param partnerIdList (optional)
     * @return Success
     * @deprecated
     */
    getCustomersByPartnerList(input: string | undefined, partnerIdList: string | undefined): Observable<CustomerDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Customer/GetCustomersByPartnerList?';
        if (input === null) throw new Error("The parameter 'input' cannot be null.");
        else if (input !== undefined) url_ += 'input=' + encodeURIComponent('' + input) + '&';
        if (partnerIdList === null) throw new Error("The parameter 'partnerIdList' cannot be null.");
        else if (partnerIdList !== undefined) url_ += 'partnerIdList=' + encodeURIComponent('' + partnerIdList) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCustomersByPartnerList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCustomersByPartnerList(<any>response_);
                        } catch (e) {
                            return <Observable<CustomerDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CustomerDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCustomersByPartnerList(response: HttpResponseBase): Observable<CustomerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(CustomerDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CustomerDto[]>([]);
    }

    /**
     * @param paramPartnerIdList (optional)
     * @return Success
     * @deprecated
     */
    getCustomerListByPartners(paramPartnerIdList: string | undefined): Observable<CustomerSummaryDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Customer/GetCustomerListByPartners?';
        if (paramPartnerIdList === null) throw new Error("The parameter 'paramPartnerIdList' cannot be null.");
        else if (paramPartnerIdList !== undefined) url_ += 'paramPartnerIdList=' + encodeURIComponent('' + paramPartnerIdList) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCustomerListByPartners(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCustomerListByPartners(<any>response_);
                        } catch (e) {
                            return <Observable<CustomerSummaryDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CustomerSummaryDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCustomerListByPartners(response: HttpResponseBase): Observable<CustomerSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(CustomerSummaryDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CustomerSummaryDto[]>([]);
    }

    /**
     * @param id (optional)
     * @return Success
     * @deprecated
     */
    getCustomerLocationList(id: number | undefined): Observable<CustomerLocationListForQuote[]> {
        let url_ = this.baseUrl + '/api/services/app/Customer/GetCustomerLocationList?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCustomerLocationList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCustomerLocationList(<any>response_);
                        } catch (e) {
                            return <Observable<CustomerLocationListForQuote[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CustomerLocationListForQuote[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCustomerLocationList(response: HttpResponseBase): Observable<CustomerLocationListForQuote[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(CustomerLocationListForQuote.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CustomerLocationListForQuote[]>([]);
    }

    /**
     * @param id (optional)
     * @return Success
     * @deprecated
     */
    deleteCustomer(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Customer/DeleteCustomer?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteCustomer(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteCustomer(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteCustomer(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     * @deprecated
     */
    validateCustomerAddress(body: CustomerAddressValidateInput | undefined): Observable<CustomerAddressValidateOutput> {
        let url_ = this.baseUrl + '/api/services/app/Customer/ValidateCustomerAddress';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processValidateCustomerAddress(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processValidateCustomerAddress(<any>response_);
                        } catch (e) {
                            return <Observable<CustomerAddressValidateOutput>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CustomerAddressValidateOutput>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processValidateCustomerAddress(response: HttpResponseBase): Observable<CustomerAddressValidateOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = CustomerAddressValidateOutput.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CustomerAddressValidateOutput>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     * @deprecated
     */
    createOrUpdateCustomer(body: CreateOrUpdateCustomerInput | undefined): Observable<number> {
        let url_ = this.baseUrl + '/api/services/app/Customer/CreateOrUpdateCustomer';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateCustomer(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateCustomer(<any>response_);
                        } catch (e) {
                            return <Observable<number>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<number>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateCustomer(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     * @deprecated
     */
    getCustomerForEdit(id: number | undefined): Observable<GetCustomerForEditOutput> {
        let url_ = this.baseUrl + '/api/services/app/Customer/GetCustomerForEdit?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCustomerForEdit(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCustomerForEdit(<any>response_);
                        } catch (e) {
                            return <Observable<GetCustomerForEditOutput>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<GetCustomerForEditOutput>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCustomerForEdit(response: HttpResponseBase): Observable<GetCustomerForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = GetCustomerForEditOutput.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<GetCustomerForEditOutput>(<any>null);
    }

    /**
     * @param filter (optional)
     * @param name (optional)
     * @param customerId (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     * @deprecated
     */
    getCustomerLocationForSelectedCustomer(
        filter: string | undefined,
        name: string | undefined,
        customerId: number | undefined,
        sorting: string | undefined,
        maxResultCount: number | undefined,
        skipCount: number | undefined
    ): Observable<CustomerLocationListPagedResultDto> {
        let url_ = this.baseUrl + '/api/services/app/Customer/GetCustomerLocationForSelectedCustomer?';
        if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
        if (name === null) throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined) url_ += 'Name=' + encodeURIComponent('' + name) + '&';
        if (customerId === null) throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined) url_ += 'CustomerId=' + encodeURIComponent('' + customerId) + '&';
        if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCustomerLocationForSelectedCustomer(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCustomerLocationForSelectedCustomer(<any>response_);
                        } catch (e) {
                            return <Observable<CustomerLocationListPagedResultDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CustomerLocationListPagedResultDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCustomerLocationForSelectedCustomer(response: HttpResponseBase): Observable<CustomerLocationListPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = CustomerLocationListPagedResultDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CustomerLocationListPagedResultDto>(<any>null);
    }

    /**
     * @param filter (optional)
     * @param name (optional)
     * @param customerId (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     * @deprecated
     */
    getSelectedCustomerContacts(
        filter: string | undefined,
        name: string | undefined,
        customerId: number | undefined,
        sorting: string | undefined,
        maxResultCount: number | undefined,
        skipCount: number | undefined
    ): Observable<CustomerContactListPagedResultDto> {
        let url_ = this.baseUrl + '/api/services/app/Customer/GetSelectedCustomerContacts?';
        if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
        if (name === null) throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined) url_ += 'Name=' + encodeURIComponent('' + name) + '&';
        if (customerId === null) throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined) url_ += 'CustomerId=' + encodeURIComponent('' + customerId) + '&';
        if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetSelectedCustomerContacts(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetSelectedCustomerContacts(<any>response_);
                        } catch (e) {
                            return <Observable<CustomerContactListPagedResultDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CustomerContactListPagedResultDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetSelectedCustomerContacts(response: HttpResponseBase): Observable<CustomerContactListPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = CustomerContactListPagedResultDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CustomerContactListPagedResultDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     * @deprecated
     */
    createOrUpdateCustomerContact(body: CreateOrUpdateCustomerContactInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Customer/CreateOrUpdateCustomerContact';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateCustomerContact(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateCustomerContact(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateCustomerContact(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     * @deprecated
     */
    deleteCustomerContact(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Customer/DeleteCustomerContact?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteCustomerContact(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteCustomerContact(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteCustomerContact(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     * @deprecated
     */
    validateCustomerLocationAddress(body: CustomerLocationValidateInput | undefined): Observable<CustomerLocationAddressValidateOutput> {
        let url_ = this.baseUrl + '/api/services/app/Customer/ValidateCustomerLocationAddress';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processValidateCustomerLocationAddress(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processValidateCustomerLocationAddress(<any>response_);
                        } catch (e) {
                            return <Observable<CustomerLocationAddressValidateOutput>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CustomerLocationAddressValidateOutput>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processValidateCustomerLocationAddress(response: HttpResponseBase): Observable<CustomerLocationAddressValidateOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = CustomerLocationAddressValidateOutput.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CustomerLocationAddressValidateOutput>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     * @deprecated
     */
    createOrUpdateCustomerLocation(body: CreateOrUpdateCustomerLocationInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Customer/CreateOrUpdateCustomerLocation';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateCustomerLocation(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateCustomerLocation(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateCustomerLocation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional)
     * @param customerId (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     * @deprecated
     */
    getQuoteTabDetails(
        filter: string | undefined,
        customerId: number | undefined,
        sorting: string | undefined,
        maxResultCount: number | undefined,
        skipCount: number | undefined
    ): Observable<QuoteTabDetailsDtoPagedResultDto> {
        let url_ = this.baseUrl + '/api/services/app/Customer/GetQuoteTabDetails?';
        if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
        if (customerId === null) throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined) url_ += 'CustomerId=' + encodeURIComponent('' + customerId) + '&';
        if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetQuoteTabDetails(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetQuoteTabDetails(<any>response_);
                        } catch (e) {
                            return <Observable<QuoteTabDetailsDtoPagedResultDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<QuoteTabDetailsDtoPagedResultDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetQuoteTabDetails(response: HttpResponseBase): Observable<QuoteTabDetailsDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = QuoteTabDetailsDtoPagedResultDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<QuoteTabDetailsDtoPagedResultDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     * @deprecated
     */
    getCustomerAssignedUsersList(id: number | undefined): Observable<UserListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Customer/GetCustomerAssignedUsersList?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCustomerAssignedUsersList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCustomerAssignedUsersList(<any>response_);
                        } catch (e) {
                            return <Observable<UserListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<UserListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCustomerAssignedUsersList(response: HttpResponseBase): Observable<UserListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(UserListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<UserListDto[]>([]);
    }

    /**
     * @param input (optional)
     * @return Success
     * @deprecated
     */
    getFilteredCustomerList(input: string | undefined): Observable<FilteredCustomerListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Customer/GetFilteredCustomerList?';
        if (input === null) throw new Error("The parameter 'input' cannot be null.");
        else if (input !== undefined) url_ += 'input=' + encodeURIComponent('' + input) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetFilteredCustomerList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetFilteredCustomerList(<any>response_);
                        } catch (e) {
                            return <Observable<FilteredCustomerListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<FilteredCustomerListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetFilteredCustomerList(response: HttpResponseBase): Observable<FilteredCustomerListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(FilteredCustomerListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<FilteredCustomerListDto[]>([]);
    }
}

@Injectable()
export class CustomerLocationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param assetPropertySearchValue (optional)
     * @param filter (optional)
     * @param companyName (optional)
     * @param address (optional)
     * @param city (optional)
     * @param state (optional)
     * @param id (optional)
     * @param customerId (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getCustomerLocations(
        assetPropertySearchValue: string | undefined,
        filter: string | undefined,
        companyName: string | undefined,
        address: string | undefined,
        city: string | undefined,
        state: string | undefined,
        id: number | undefined,
        customerId: number | undefined,
        sorting: string | undefined,
        maxResultCount: number | undefined,
        skipCount: number | undefined
    ): Observable<CustomerLocationDetailDtoPagedResultDto> {
        let url_ = this.baseUrl + '/api/services/app/CustomerLocation/GetCustomerLocations?';
        if (assetPropertySearchValue === null) throw new Error("The parameter 'assetPropertySearchValue' cannot be null.");
        else if (assetPropertySearchValue !== undefined)
            url_ += 'assetPropertySearchValue=' + encodeURIComponent('' + assetPropertySearchValue) + '&';
        if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
        if (companyName === null) throw new Error("The parameter 'companyName' cannot be null.");
        else if (companyName !== undefined) url_ += 'CompanyName=' + encodeURIComponent('' + companyName) + '&';
        if (address === null) throw new Error("The parameter 'address' cannot be null.");
        else if (address !== undefined) url_ += 'Address=' + encodeURIComponent('' + address) + '&';
        if (city === null) throw new Error("The parameter 'city' cannot be null.");
        else if (city !== undefined) url_ += 'City=' + encodeURIComponent('' + city) + '&';
        if (state === null) throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined) url_ += 'State=' + encodeURIComponent('' + state) + '&';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        if (customerId === null) throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined) url_ += 'CustomerId=' + encodeURIComponent('' + customerId) + '&';
        if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCustomerLocations(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCustomerLocations(<any>response_);
                        } catch (e) {
                            return <Observable<CustomerLocationDetailDtoPagedResultDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CustomerLocationDetailDtoPagedResultDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCustomerLocations(response: HttpResponseBase): Observable<CustomerLocationDetailDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = CustomerLocationDetailDtoPagedResultDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CustomerLocationDetailDtoPagedResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    getCustomerLocationsAll(): Observable<CustLocationFilteredListDto> {
        let url_ = this.baseUrl + '/api/services/app/CustomerLocation/GetCustomerLocationsAll';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCustomerLocationsAll(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCustomerLocationsAll(<any>response_);
                        } catch (e) {
                            return <Observable<CustLocationFilteredListDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CustLocationFilteredListDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCustomerLocationsAll(response: HttpResponseBase): Observable<CustLocationFilteredListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = CustLocationFilteredListDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CustLocationFilteredListDto>(<any>null);
    }

    /**
     * @param filter (optional)
     * @param customerId (optional)
     * @param partnerId (optional)
     * @return Success
     */
    getLocationsList(
        filter: string | undefined,
        customerId: number | undefined,
        partnerId: number | undefined
    ): Observable<CustomerLocationDto[]> {
        let url_ = this.baseUrl + '/api/services/app/CustomerLocation/GetLocationsList?';
        if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
        if (customerId === null) throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined) url_ += 'CustomerId=' + encodeURIComponent('' + customerId) + '&';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'PartnerId=' + encodeURIComponent('' + partnerId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetLocationsList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetLocationsList(<any>response_);
                        } catch (e) {
                            return <Observable<CustomerLocationDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CustomerLocationDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetLocationsList(response: HttpResponseBase): Observable<CustomerLocationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(CustomerLocationDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CustomerLocationDto[]>([]);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateCustomerLocation(body: CreateOrUpdateCustLocationInput | undefined): Observable<CustLocationListDto> {
        let url_ = this.baseUrl + '/api/services/app/CustomerLocation/CreateOrUpdateCustomerLocation';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateCustomerLocation(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateCustomerLocation(<any>response_);
                        } catch (e) {
                            return <Observable<CustLocationListDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CustLocationListDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateCustomerLocation(response: HttpResponseBase): Observable<CustLocationListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = CustLocationListDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CustLocationListDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateCustomerLocationContact(body: CreateOrUpdateCustLocationContactInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/CustomerLocation/CreateOrUpdateCustomerLocationContact';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateCustomerLocationContact(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateCustomerLocationContact(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateCustomerLocationContact(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional)
     * @param name (optional)
     * @param id (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getCustomerLocationContacts(
        filter: string | undefined,
        name: string | undefined,
        id: number | undefined,
        sorting: string | undefined,
        maxResultCount: number | undefined,
        skipCount: number | undefined
    ): Observable<CustLocationContactListDtoPagedResultDto> {
        let url_ = this.baseUrl + '/api/services/app/CustomerLocation/GetCustomerLocationContacts?';
        if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
        if (name === null) throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined) url_ += 'Name=' + encodeURIComponent('' + name) + '&';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCustomerLocationContacts(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCustomerLocationContacts(<any>response_);
                        } catch (e) {
                            return <Observable<CustLocationContactListDtoPagedResultDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CustLocationContactListDtoPagedResultDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCustomerLocationContacts(response: HttpResponseBase): Observable<CustLocationContactListDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = CustLocationContactListDtoPagedResultDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CustLocationContactListDtoPagedResultDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getLocationForEdit(id: number | undefined): Observable<GetLocationForEditOutput> {
        let url_ = this.baseUrl + '/api/services/app/CustomerLocation/GetLocationForEdit?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetLocationForEdit(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetLocationForEdit(<any>response_);
                        } catch (e) {
                            return <Observable<GetLocationForEditOutput>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<GetLocationForEditOutput>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetLocationForEdit(response: HttpResponseBase): Observable<GetLocationForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = GetLocationForEditOutput.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<GetLocationForEditOutput>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getLocationDetailsTileData(id: number | undefined): Observable<GetLocationDetailsTileDataOutput> {
        let url_ = this.baseUrl + '/api/services/app/CustomerLocation/GetLocationDetailsTileData?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetLocationDetailsTileData(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetLocationDetailsTileData(<any>response_);
                        } catch (e) {
                            return <Observable<GetLocationDetailsTileDataOutput>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<GetLocationDetailsTileDataOutput>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetLocationDetailsTileData(response: HttpResponseBase): Observable<GetLocationDetailsTileDataOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = GetLocationDetailsTileDataOutput.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<GetLocationDetailsTileDataOutput>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteCustomerLocation(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/CustomerLocation/DeleteCustomerLocation?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteCustomerLocation(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteCustomerLocation(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteCustomerLocation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateLocationFile(body: UploadFileInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/CustomerLocation/UpdateLocationFile';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateLocationFile(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateLocationFile(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdateLocationFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }
}

export class CreateOrUpdateCustLocationContactInput implements ICreateOrUpdateCustLocationContactInput {
    customerLocationContact: CustLocationContactEditDto;

    constructor(data?: ICreateOrUpdateCustLocationContactInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.customerLocationContact = new CustLocationContactEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerLocationContact = _data['customerLocationContact']
                ? CustLocationContactEditDto.fromJS(_data['customerLocationContact'])
                : new CustLocationContactEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateCustLocationContactInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateCustLocationContactInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['customerLocationContact'] = this.customerLocationContact ? this.customerLocationContact.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateCustLocationContactInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateCustLocationContactInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateCustLocationContactInput {
    customerLocationContact: CustLocationContactEditDto;
}

export class CreateOrUpdateCustLocationInput implements ICreateOrUpdateCustLocationInput {
    customerLocation: CustomerLocationEditDto;

    constructor(data?: ICreateOrUpdateCustLocationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.customerLocation = new CustomerLocationEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerLocation = _data['customerLocation']
                ? CustomerLocationEditDto.fromJS(_data['customerLocation'])
                : new CustomerLocationEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateCustLocationInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateCustLocationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['customerLocation'] = this.customerLocation ? this.customerLocation.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateCustLocationInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateCustLocationInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateCustLocationInput {
    customerLocation: CustomerLocationEditDto;
}

export class CreateOrUpdateCustomerContactInput implements ICreateOrUpdateCustomerContactInput {
    customerContact: CustomerContactEditDto;

    constructor(data?: ICreateOrUpdateCustomerContactInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.customerContact = new CustomerContactEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerContact = _data['customerContact']
                ? CustomerContactEditDto.fromJS(_data['customerContact'])
                : new CustomerContactEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateCustomerContactInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateCustomerContactInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['customerContact'] = this.customerContact ? this.customerContact.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateCustomerContactInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateCustomerContactInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateCustomerContactInput {
    customerContact: CustomerContactEditDto;
}

export class CreateOrUpdateCustomerInput implements ICreateOrUpdateCustomerInput {
    customer: CustomerEditDto;

    constructor(data?: ICreateOrUpdateCustomerInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.customer = new CustomerEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customer = _data['customer'] ? CustomerEditDto.fromJS(_data['customer']) : new CustomerEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateCustomerInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateCustomerInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['customer'] = this.customer ? this.customer.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateCustomerInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateCustomerInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateCustomerInput {
    customer: CustomerEditDto;
}

export class CreateOrUpdateCustomerLocationInput implements ICreateOrUpdateCustomerLocationInput {
    id: number;
    customerId: number;
    name: string;
    address: string;
    address2: string | undefined;
    city: string;
    state: string;
    zipcode: string;
    country: string | undefined;

    constructor(data?: ICreateOrUpdateCustomerLocationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.customerId = _data['customerId'];
            this.name = _data['name'];
            this.address = _data['address'];
            this.address2 = _data['address2'];
            this.city = _data['city'];
            this.state = _data['state'];
            this.zipcode = _data['zipcode'];
            this.country = _data['country'];
        }
    }

    static fromJS(data: any): CreateOrUpdateCustomerLocationInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateCustomerLocationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['customerId'] = this.customerId;
        data['name'] = this.name;
        data['address'] = this.address;
        data['address2'] = this.address2;
        data['city'] = this.city;
        data['state'] = this.state;
        data['zipcode'] = this.zipcode;
        data['country'] = this.country;
        return data;
    }

    clone(): CreateOrUpdateCustomerLocationInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateCustomerLocationInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateCustomerLocationInput {
    id: number;
    customerId: number;
    name: string;
    address: string;
    address2: string | undefined;
    city: string;
    state: string;
    zipcode: string;
    country: string | undefined;
}

export class CustLocationContactEditDto implements ICustLocationContactEditDto {
    customerLocationId: number;
    type: ContactType;
    number: string;
    id: number;

    constructor(data?: ICustLocationContactEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerLocationId = _data['customerLocationId'];
            this.type = _data['type'];
            this.number = _data['number'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): CustLocationContactEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustLocationContactEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['customerLocationId'] = this.customerLocationId;
        data['type'] = this.type;
        data['number'] = this.number;
        data['id'] = this.id;
        return data;
    }

    clone(): CustLocationContactEditDto {
        const json = this.toJSON();
        let result = new CustLocationContactEditDto();
        result.init(json);
        return result;
    }
}

export interface ICustLocationContactEditDto {
    customerLocationId: number;
    type: ContactType;
    number: string;
    id: number;
}

export class CustLocationContactListDto implements ICustLocationContactListDto {
    customerLocationId: number;
    type: ContactType;
    number: string | undefined;
    id: number;

    constructor(data?: ICustLocationContactListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerLocationId = _data['customerLocationId'];
            this.type = _data['type'];
            this.number = _data['number'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): CustLocationContactListDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustLocationContactListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['customerLocationId'] = this.customerLocationId;
        data['type'] = this.type;
        data['number'] = this.number;
        data['id'] = this.id;
        return data;
    }

    clone(): CustLocationContactListDto {
        const json = this.toJSON();
        let result = new CustLocationContactListDto();
        result.init(json);
        return result;
    }
}

export interface ICustLocationContactListDto {
    customerLocationId: number;
    type: ContactType;
    number: string | undefined;
    id: number;
}

export class CustLocationContactListDtoPagedResultDto implements ICustLocationContactListDtoPagedResultDto {
    totalCount: number;
    items: CustLocationContactListDto[] | undefined;

    constructor(data?: ICustLocationContactListDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data['totalCount'];
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(CustLocationContactListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustLocationContactListDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustLocationContactListDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['totalCount'] = this.totalCount;
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }

    clone(): CustLocationContactListDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CustLocationContactListDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICustLocationContactListDtoPagedResultDto {
    totalCount: number;
    items: CustLocationContactListDto[] | undefined;
}

export class CustLocationFilteredListDto implements ICustLocationFilteredListDto {
    city: GetCityListDto[] | undefined;
    state: GetStateListDto[] | undefined;
    companyName: GetCompanyNameListDto[] | undefined;
    address: GetLocationAddressListDto[] | undefined;

    constructor(data?: ICustLocationFilteredListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['city'])) {
                this.city = [] as any;
                for (let item of _data['city']) this.city.push(GetCityListDto.fromJS(item));
            }
            if (Array.isArray(_data['state'])) {
                this.state = [] as any;
                for (let item of _data['state']) this.state.push(GetStateListDto.fromJS(item));
            }
            if (Array.isArray(_data['companyName'])) {
                this.companyName = [] as any;
                for (let item of _data['companyName']) this.companyName.push(GetCompanyNameListDto.fromJS(item));
            }
            if (Array.isArray(_data['address'])) {
                this.address = [] as any;
                for (let item of _data['address']) this.address.push(GetLocationAddressListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustLocationFilteredListDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustLocationFilteredListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.city)) {
            data['city'] = [];
            for (let item of this.city) data['city'].push(item.toJSON());
        }
        if (Array.isArray(this.state)) {
            data['state'] = [];
            for (let item of this.state) data['state'].push(item.toJSON());
        }
        if (Array.isArray(this.companyName)) {
            data['companyName'] = [];
            for (let item of this.companyName) data['companyName'].push(item.toJSON());
        }
        if (Array.isArray(this.address)) {
            data['address'] = [];
            for (let item of this.address) data['address'].push(item.toJSON());
        }
        return data;
    }

    clone(): CustLocationFilteredListDto {
        const json = this.toJSON();
        let result = new CustLocationFilteredListDto();
        result.init(json);
        return result;
    }
}

export interface ICustLocationFilteredListDto {
    city: GetCityListDto[] | undefined;
    state: GetStateListDto[] | undefined;
    companyName: GetCompanyNameListDto[] | undefined;
    address: GetLocationAddressListDto[] | undefined;
}

export class CustLocationListDto implements ICustLocationListDto {
    customerId: number;
    customerName: string | undefined;
    name: string;
    address: string;
    address2: string | undefined;
    city: string;
    state: string;
    zipcode: string | undefined;
    country: string | undefined;
    id: number;

    constructor(data?: ICustLocationListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data['customerId'];
            this.customerName = _data['customerName'];
            this.name = _data['name'];
            this.address = _data['address'];
            this.address2 = _data['address2'];
            this.city = _data['city'];
            this.state = _data['state'];
            this.zipcode = _data['zipcode'];
            this.country = _data['country'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): CustLocationListDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustLocationListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['customerId'] = this.customerId;
        data['customerName'] = this.customerName;
        data['name'] = this.name;
        data['address'] = this.address;
        data['address2'] = this.address2;
        data['city'] = this.city;
        data['state'] = this.state;
        data['zipcode'] = this.zipcode;
        data['country'] = this.country;
        data['id'] = this.id;
        return data;
    }

    clone(): CustLocationListDto {
        const json = this.toJSON();
        let result = new CustLocationListDto();
        result.init(json);
        return result;
    }
}

export interface ICustLocationListDto {
    customerId: number;
    customerName: string | undefined;
    name: string;
    address: string;
    address2: string | undefined;
    city: string;
    state: string;
    zipcode: string | undefined;
    country: string | undefined;
    id: number;
}

export class CustomerAddressValidateInput implements ICustomerAddressValidateInput {
    customerName: string | undefined;
    partnerId: number;
    address: string | undefined;
    address2: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zip: string | undefined;
    country: string | undefined;

    constructor(data?: ICustomerAddressValidateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerName = _data['customerName'];
            this.partnerId = _data['partnerId'];
            this.address = _data['address'];
            this.address2 = _data['address2'];
            this.city = _data['city'];
            this.state = _data['state'];
            this.zip = _data['zip'];
            this.country = _data['country'];
        }
    }

    static fromJS(data: any): CustomerAddressValidateInput {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerAddressValidateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['customerName'] = this.customerName;
        data['partnerId'] = this.partnerId;
        data['address'] = this.address;
        data['address2'] = this.address2;
        data['city'] = this.city;
        data['state'] = this.state;
        data['zip'] = this.zip;
        data['country'] = this.country;
        return data;
    }

    clone(): CustomerAddressValidateInput {
        const json = this.toJSON();
        let result = new CustomerAddressValidateInput();
        result.init(json);
        return result;
    }
}

export interface ICustomerAddressValidateInput {
    customerName: string | undefined;
    partnerId: number;
    address: string | undefined;
    address2: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zip: string | undefined;
    country: string | undefined;
}

export class CustomerAddressValidateOutput implements ICustomerAddressValidateOutput {
    result: CustomerAddressValidationInformation[] | undefined;
    readonly messageType: string | undefined;
    readonly message: string | undefined;

    constructor(data?: ICustomerAddressValidateOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['result'])) {
                this.result = [] as any;
                for (let item of _data['result']) this.result.push(CustomerAddressValidationInformation.fromJS(item));
            }
            (<any>this).messageType = _data['messageType'];
            (<any>this).message = _data['message'];
        }
    }

    static fromJS(data: any): CustomerAddressValidateOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerAddressValidateOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data['result'] = [];
            for (let item of this.result) data['result'].push(item.toJSON());
        }
        data['messageType'] = this.messageType;
        data['message'] = this.message;
        return data;
    }

    clone(): CustomerAddressValidateOutput {
        const json = this.toJSON();
        let result = new CustomerAddressValidateOutput();
        result.init(json);
        return result;
    }
}

export interface ICustomerAddressValidateOutput {
    result: CustomerAddressValidationInformation[] | undefined;
    messageType: string | undefined;
    message: string | undefined;
}

export class CustomerAddressValidationInformation implements ICustomerAddressValidationInformation {
    partnerId: number | undefined;
    partnerName: string | undefined;
    customerId: number;
    customerName: string | undefined;
    address: string | undefined;
    address2: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
    zipcode: string | undefined;
    orders: CustomerAddressValidationOrderInformation[] | undefined;
    readonly fullAddress: string | undefined;

    constructor(data?: ICustomerAddressValidationInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerId = _data['partnerId'];
            this.partnerName = _data['partnerName'];
            this.customerId = _data['customerId'];
            this.customerName = _data['customerName'];
            this.address = _data['address'];
            this.address2 = _data['address2'];
            this.city = _data['city'];
            this.state = _data['state'];
            this.country = _data['country'];
            this.zipcode = _data['zipcode'];
            if (Array.isArray(_data['orders'])) {
                this.orders = [] as any;
                for (let item of _data['orders']) this.orders.push(CustomerAddressValidationOrderInformation.fromJS(item));
            }
            (<any>this).fullAddress = _data['fullAddress'];
        }
    }

    static fromJS(data: any): CustomerAddressValidationInformation {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerAddressValidationInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['partnerId'] = this.partnerId;
        data['partnerName'] = this.partnerName;
        data['customerId'] = this.customerId;
        data['customerName'] = this.customerName;
        data['address'] = this.address;
        data['address2'] = this.address2;
        data['city'] = this.city;
        data['state'] = this.state;
        data['country'] = this.country;
        data['zipcode'] = this.zipcode;
        if (Array.isArray(this.orders)) {
            data['orders'] = [];
            for (let item of this.orders) data['orders'].push(item.toJSON());
        }
        data['fullAddress'] = this.fullAddress;
        return data;
    }

    clone(): CustomerAddressValidationInformation {
        const json = this.toJSON();
        let result = new CustomerAddressValidationInformation();
        result.init(json);
        return result;
    }
}

export interface ICustomerAddressValidationInformation {
    partnerId: number | undefined;
    partnerName: string | undefined;
    customerId: number;
    customerName: string | undefined;
    address: string | undefined;
    address2: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
    zipcode: string | undefined;
    orders: CustomerAddressValidationOrderInformation[] | undefined;
    fullAddress: string | undefined;
}

export class CustomerAddressValidationOrderInformation implements ICustomerAddressValidationOrderInformation {
    orderId: number | undefined;
    orderNumber: string | undefined;
    productName: string | undefined;
    partnerName: string | undefined;
    orderStatusName: string | undefined;
    contractStartDate: moment.Moment | undefined;
    contractEndDate: moment.Moment | undefined;
    providerName: string | undefined;

    constructor(data?: ICustomerAddressValidationOrderInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data['orderId'];
            this.orderNumber = _data['orderNumber'];
            this.productName = _data['productName'];
            this.partnerName = _data['partnerName'];
            this.orderStatusName = _data['orderStatusName'];
            this.contractStartDate = _data['contractStartDate'] ? moment(_data['contractStartDate'].toString()) : <any>undefined;
            this.contractEndDate = _data['contractEndDate'] ? moment(_data['contractEndDate'].toString()) : <any>undefined;
            this.providerName = _data['providerName'];
        }
    }

    static fromJS(data: any): CustomerAddressValidationOrderInformation {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerAddressValidationOrderInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['orderId'] = this.orderId;
        data['orderNumber'] = this.orderNumber;
        data['productName'] = this.productName;
        data['partnerName'] = this.partnerName;
        data['orderStatusName'] = this.orderStatusName;
        data['contractStartDate'] = this.contractStartDate ? this.contractStartDate.toISOString() : <any>undefined;
        data['contractEndDate'] = this.contractEndDate ? this.contractEndDate.toISOString() : <any>undefined;
        data['providerName'] = this.providerName;
        return data;
    }

    clone(): CustomerAddressValidationOrderInformation {
        const json = this.toJSON();
        let result = new CustomerAddressValidationOrderInformation();
        result.init(json);
        return result;
    }
}

export interface ICustomerAddressValidationOrderInformation {
    orderId: number | undefined;
    orderNumber: string | undefined;
    productName: string | undefined;
    partnerName: string | undefined;
    orderStatusName: string | undefined;
    contractStartDate: moment.Moment | undefined;
    contractEndDate: moment.Moment | undefined;
    providerName: string | undefined;
}

export class CustomerContactEditDto implements ICustomerContactEditDto {
    customerId: number;
    type: ContactType;
    number: string;
    id: number;

    constructor(data?: ICustomerContactEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data['customerId'];
            this.type = _data['type'];
            this.number = _data['number'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): CustomerContactEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerContactEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['customerId'] = this.customerId;
        data['type'] = this.type;
        data['number'] = this.number;
        data['id'] = this.id;
        return data;
    }

    clone(): CustomerContactEditDto {
        const json = this.toJSON();
        let result = new CustomerContactEditDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerContactEditDto {
    customerId: number;
    type: ContactType;
    number: string;
    id: number;
}

export class CustomerContactList implements ICustomerContactList {
    customerId: number;
    type: ContactType;
    number: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ICustomerContactList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data['customerId'];
            this.type = _data['type'];
            this.number = _data['number'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): CustomerContactList {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerContactList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['customerId'] = this.customerId;
        data['type'] = this.type;
        data['number'] = this.number;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): CustomerContactList {
        const json = this.toJSON();
        let result = new CustomerContactList();
        result.init(json);
        return result;
    }
}

export interface ICustomerContactList {
    customerId: number;
    type: ContactType;
    number: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class CustomerContactListPagedResultDto implements ICustomerContactListPagedResultDto {
    totalCount: number;
    items: CustomerContactList[] | undefined;

    constructor(data?: ICustomerContactListPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data['totalCount'];
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(CustomerContactList.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerContactListPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerContactListPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['totalCount'] = this.totalCount;
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }

    clone(): CustomerContactListPagedResultDto {
        const json = this.toJSON();
        let result = new CustomerContactListPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerContactListPagedResultDto {
    totalCount: number;
    items: CustomerContactList[] | undefined;
}

export class CustomerListDtoPagedResultDto implements ICustomerListDtoPagedResultDto {
    totalCount: number;
    items: CustomerListDto[] | undefined;

    constructor(data?: ICustomerListDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data['totalCount'];
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(CustomerListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerListDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerListDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['totalCount'] = this.totalCount;
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }

    clone(): CustomerListDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CustomerListDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerListDtoPagedResultDto {
    totalCount: number;
    items: CustomerListDto[] | undefined;
}

export class CustomerLocationAddressInformation implements ICustomerLocationAddressInformation {
    partnerId: number | undefined;
    partnerName: string | undefined;
    customerId: number;
    customerLocationName: string | undefined;
    customerLocationId: number;
    address: string | undefined;
    address2: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
    zipcode: string | undefined;
    orders: CustomerLocationValidationOrderInformation[] | undefined;
    readonly fullAddress: string | undefined;

    constructor(data?: ICustomerLocationAddressInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerId = _data['partnerId'];
            this.partnerName = _data['partnerName'];
            this.customerId = _data['customerId'];
            this.customerLocationName = _data['customerLocationName'];
            this.customerLocationId = _data['customerLocationId'];
            this.address = _data['address'];
            this.address2 = _data['address2'];
            this.city = _data['city'];
            this.state = _data['state'];
            this.country = _data['country'];
            this.zipcode = _data['zipcode'];
            if (Array.isArray(_data['orders'])) {
                this.orders = [] as any;
                for (let item of _data['orders']) this.orders.push(CustomerLocationValidationOrderInformation.fromJS(item));
            }
            (<any>this).fullAddress = _data['fullAddress'];
        }
    }

    static fromJS(data: any): CustomerLocationAddressInformation {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerLocationAddressInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['partnerId'] = this.partnerId;
        data['partnerName'] = this.partnerName;
        data['customerId'] = this.customerId;
        data['customerLocationName'] = this.customerLocationName;
        data['customerLocationId'] = this.customerLocationId;
        data['address'] = this.address;
        data['address2'] = this.address2;
        data['city'] = this.city;
        data['state'] = this.state;
        data['country'] = this.country;
        data['zipcode'] = this.zipcode;
        if (Array.isArray(this.orders)) {
            data['orders'] = [];
            for (let item of this.orders) data['orders'].push(item.toJSON());
        }
        data['fullAddress'] = this.fullAddress;
        return data;
    }

    clone(): CustomerLocationAddressInformation {
        const json = this.toJSON();
        let result = new CustomerLocationAddressInformation();
        result.init(json);
        return result;
    }
}

export interface ICustomerLocationAddressInformation {
    partnerId: number | undefined;
    partnerName: string | undefined;
    customerId: number;
    customerLocationName: string | undefined;
    customerLocationId: number;
    address: string | undefined;
    address2: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
    zipcode: string | undefined;
    orders: CustomerLocationValidationOrderInformation[] | undefined;
    fullAddress: string | undefined;
}

export class CustomerLocationAddressValidateOutput implements ICustomerLocationAddressValidateOutput {
    result: CustomerLocationAddressInformation[] | undefined;
    readonly messageType: string | undefined;
    readonly message: string | undefined;

    constructor(data?: ICustomerLocationAddressValidateOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['result'])) {
                this.result = [] as any;
                for (let item of _data['result']) this.result.push(CustomerLocationAddressInformation.fromJS(item));
            }
            (<any>this).messageType = _data['messageType'];
            (<any>this).message = _data['message'];
        }
    }

    static fromJS(data: any): CustomerLocationAddressValidateOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerLocationAddressValidateOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data['result'] = [];
            for (let item of this.result) data['result'].push(item.toJSON());
        }
        data['messageType'] = this.messageType;
        data['message'] = this.message;
        return data;
    }

    clone(): CustomerLocationAddressValidateOutput {
        const json = this.toJSON();
        let result = new CustomerLocationAddressValidateOutput();
        result.init(json);
        return result;
    }
}

export interface ICustomerLocationAddressValidateOutput {
    result: CustomerLocationAddressInformation[] | undefined;
    messageType: string | undefined;
    message: string | undefined;
}

export class CustomerLocationDetailDto implements ICustomerLocationDetailDto {
    id: number;
    customerId: number;
    customerName: string | undefined;
    name: string;
    address: string;
    address2: string | undefined;
    city: string;
    state: string;
    zipcode: string;
    country: string | undefined;

    constructor(data?: ICustomerLocationDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.customerId = _data['customerId'];
            this.customerName = _data['customerName'];
            this.name = _data['name'];
            this.address = _data['address'];
            this.address2 = _data['address2'];
            this.city = _data['city'];
            this.state = _data['state'];
            this.zipcode = _data['zipcode'];
            this.country = _data['country'];
        }
    }

    static fromJS(data: any): CustomerLocationDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerLocationDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['customerId'] = this.customerId;
        data['customerName'] = this.customerName;
        data['name'] = this.name;
        data['address'] = this.address;
        data['address2'] = this.address2;
        data['city'] = this.city;
        data['state'] = this.state;
        data['zipcode'] = this.zipcode;
        data['country'] = this.country;
        return data;
    }

    clone(): CustomerLocationDetailDto {
        const json = this.toJSON();
        let result = new CustomerLocationDetailDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerLocationDetailDto {
    id: number;
    customerId: number;
    customerName: string | undefined;
    name: string;
    address: string;
    address2: string | undefined;
    city: string;
    state: string;
    zipcode: string;
    country: string | undefined;
}

export class CustomerLocationDetailDtoPagedResultDto implements ICustomerLocationDetailDtoPagedResultDto {
    totalCount: number;
    items: CustomerLocationDetailDto[] | undefined;

    constructor(data?: ICustomerLocationDetailDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data['totalCount'];
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(CustomerLocationDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerLocationDetailDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerLocationDetailDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['totalCount'] = this.totalCount;
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }

    clone(): CustomerLocationDetailDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CustomerLocationDetailDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerLocationDetailDtoPagedResultDto {
    totalCount: number;
    items: CustomerLocationDetailDto[] | undefined;
}

export class CustomerLocationList implements ICustomerLocationList {
    tenantId: number | undefined;
    customerId: number;
    name: string | undefined;
    address: string | undefined;
    address2: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zipcode: string | undefined;
    country: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ICustomerLocationList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.customerId = _data['customerId'];
            this.name = _data['name'];
            this.address = _data['address'];
            this.address2 = _data['address2'];
            this.city = _data['city'];
            this.state = _data['state'];
            this.zipcode = _data['zipcode'];
            this.country = _data['country'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): CustomerLocationList {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerLocationList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['customerId'] = this.customerId;
        data['name'] = this.name;
        data['address'] = this.address;
        data['address2'] = this.address2;
        data['city'] = this.city;
        data['state'] = this.state;
        data['zipcode'] = this.zipcode;
        data['country'] = this.country;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): CustomerLocationList {
        const json = this.toJSON();
        let result = new CustomerLocationList();
        result.init(json);
        return result;
    }
}

export interface ICustomerLocationList {
    tenantId: number | undefined;
    customerId: number;
    name: string | undefined;
    address: string | undefined;
    address2: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zipcode: string | undefined;
    country: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class CustomerLocationListForQuote implements ICustomerLocationListForQuote {
    customerId: number;
    name: string | undefined;
    address: string | undefined;
    address2: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zipcode: string | undefined;
    country: string | undefined;
    id: number;

    constructor(data?: ICustomerLocationListForQuote) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data['customerId'];
            this.name = _data['name'];
            this.address = _data['address'];
            this.address2 = _data['address2'];
            this.city = _data['city'];
            this.state = _data['state'];
            this.zipcode = _data['zipcode'];
            this.country = _data['country'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): CustomerLocationListForQuote {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerLocationListForQuote();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['customerId'] = this.customerId;
        data['name'] = this.name;
        data['address'] = this.address;
        data['address2'] = this.address2;
        data['city'] = this.city;
        data['state'] = this.state;
        data['zipcode'] = this.zipcode;
        data['country'] = this.country;
        data['id'] = this.id;
        return data;
    }

    clone(): CustomerLocationListForQuote {
        const json = this.toJSON();
        let result = new CustomerLocationListForQuote();
        result.init(json);
        return result;
    }
}

export interface ICustomerLocationListForQuote {
    customerId: number;
    name: string | undefined;
    address: string | undefined;
    address2: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zipcode: string | undefined;
    country: string | undefined;
    id: number;
}

export class CustomerLocationListPagedResultDto implements ICustomerLocationListPagedResultDto {
    totalCount: number;
    items: CustomerLocationList[] | undefined;

    constructor(data?: ICustomerLocationListPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data['totalCount'];
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(CustomerLocationList.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerLocationListPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerLocationListPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['totalCount'] = this.totalCount;
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }

    clone(): CustomerLocationListPagedResultDto {
        const json = this.toJSON();
        let result = new CustomerLocationListPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerLocationListPagedResultDto {
    totalCount: number;
    items: CustomerLocationList[] | undefined;
}

export class CustomerLocationValidateInput implements ICustomerLocationValidateInput {
    customerId: number;
    customerLocationName: string | undefined;
    partnerId: number;
    address: string | undefined;
    address2: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zip: string | undefined;
    country: string | undefined;

    constructor(data?: ICustomerLocationValidateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data['customerId'];
            this.customerLocationName = _data['customerLocationName'];
            this.partnerId = _data['partnerId'];
            this.address = _data['address'];
            this.address2 = _data['address2'];
            this.city = _data['city'];
            this.state = _data['state'];
            this.zip = _data['zip'];
            this.country = _data['country'];
        }
    }

    static fromJS(data: any): CustomerLocationValidateInput {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerLocationValidateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['customerId'] = this.customerId;
        data['customerLocationName'] = this.customerLocationName;
        data['partnerId'] = this.partnerId;
        data['address'] = this.address;
        data['address2'] = this.address2;
        data['city'] = this.city;
        data['state'] = this.state;
        data['zip'] = this.zip;
        data['country'] = this.country;
        return data;
    }

    clone(): CustomerLocationValidateInput {
        const json = this.toJSON();
        let result = new CustomerLocationValidateInput();
        result.init(json);
        return result;
    }
}

export interface ICustomerLocationValidateInput {
    customerId: number;
    customerLocationName: string | undefined;
    partnerId: number;
    address: string | undefined;
    address2: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zip: string | undefined;
    country: string | undefined;
}

export class CustomerLocationValidationOrderInformation implements ICustomerLocationValidationOrderInformation {
    orderId: number | undefined;
    orderNumber: string | undefined;
    productName: string | undefined;
    partnerName: string | undefined;
    orderStatusName: string | undefined;
    contractStartDate: moment.Moment | undefined;
    contractEndDate: moment.Moment | undefined;
    providerName: string | undefined;

    constructor(data?: ICustomerLocationValidationOrderInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data['orderId'];
            this.orderNumber = _data['orderNumber'];
            this.productName = _data['productName'];
            this.partnerName = _data['partnerName'];
            this.orderStatusName = _data['orderStatusName'];
            this.contractStartDate = _data['contractStartDate'] ? moment(_data['contractStartDate'].toString()) : <any>undefined;
            this.contractEndDate = _data['contractEndDate'] ? moment(_data['contractEndDate'].toString()) : <any>undefined;
            this.providerName = _data['providerName'];
        }
    }

    static fromJS(data: any): CustomerLocationValidationOrderInformation {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerLocationValidationOrderInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['orderId'] = this.orderId;
        data['orderNumber'] = this.orderNumber;
        data['productName'] = this.productName;
        data['partnerName'] = this.partnerName;
        data['orderStatusName'] = this.orderStatusName;
        data['contractStartDate'] = this.contractStartDate ? this.contractStartDate.toISOString() : <any>undefined;
        data['contractEndDate'] = this.contractEndDate ? this.contractEndDate.toISOString() : <any>undefined;
        data['providerName'] = this.providerName;
        return data;
    }

    clone(): CustomerLocationValidationOrderInformation {
        const json = this.toJSON();
        let result = new CustomerLocationValidationOrderInformation();
        result.init(json);
        return result;
    }
}

export interface ICustomerLocationValidationOrderInformation {
    orderId: number | undefined;
    orderNumber: string | undefined;
    productName: string | undefined;
    partnerName: string | undefined;
    orderStatusName: string | undefined;
    contractStartDate: moment.Moment | undefined;
    contractEndDate: moment.Moment | undefined;
    providerName: string | undefined;
}

export class CustomerSummaryDto implements ICustomerSummaryDto {
    id: number;
    name: string | undefined;

    constructor(data?: ICustomerSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
        }
    }

    static fromJS(data: any): CustomerSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        return data;
    }

    clone(): CustomerSummaryDto {
        const json = this.toJSON();
        let result = new CustomerSummaryDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerSummaryDto {
    id: number;
    name: string | undefined;
}

export class FilteredCustomerListDto implements IFilteredCustomerListDto {
    id: number;
    name: string | undefined;
    partnerId: number;

    constructor(data?: IFilteredCustomerListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.partnerId = _data['partnerId'];
        }
    }

    static fromJS(data: any): FilteredCustomerListDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilteredCustomerListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['partnerId'] = this.partnerId;
        return data;
    }

    clone(): FilteredCustomerListDto {
        const json = this.toJSON();
        let result = new FilteredCustomerListDto();
        result.init(json);
        return result;
    }
}

export interface IFilteredCustomerListDto {
    id: number;
    name: string | undefined;
    partnerId: number;
}

export class GetCityListDto implements IGetCityListDto {
    city: string | undefined;
    id: number;

    constructor(data?: IGetCityListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.city = _data['city'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): GetCityListDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCityListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['city'] = this.city;
        data['id'] = this.id;
        return data;
    }

    clone(): GetCityListDto {
        const json = this.toJSON();
        let result = new GetCityListDto();
        result.init(json);
        return result;
    }
}

export interface IGetCityListDto {
    city: string | undefined;
    id: number;
}

export class GetCompanyNameListDto implements IGetCompanyNameListDto {
    name: string | undefined;
    id: number;

    constructor(data?: IGetCompanyNameListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): GetCompanyNameListDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyNameListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['id'] = this.id;
        return data;
    }

    clone(): GetCompanyNameListDto {
        const json = this.toJSON();
        let result = new GetCompanyNameListDto();
        result.init(json);
        return result;
    }
}

export interface IGetCompanyNameListDto {
    name: string | undefined;
    id: number;
}

export class GetCustomerForEditOutput implements IGetCustomerForEditOutput {
    customer: CustomerEditDto;
    isValidUser: boolean;

    constructor(data?: IGetCustomerForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customer = _data['customer'] ? CustomerEditDto.fromJS(_data['customer']) : <any>undefined;
            this.isValidUser = _data['isValidUser'];
        }
    }

    static fromJS(data: any): GetCustomerForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomerForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['customer'] = this.customer ? this.customer.toJSON() : <any>undefined;
        data['isValidUser'] = this.isValidUser;
        return data;
    }

    clone(): GetCustomerForEditOutput {
        const json = this.toJSON();
        let result = new GetCustomerForEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetCustomerForEditOutput {
    customer: CustomerEditDto;
    isValidUser: boolean;
}

export class GetLocationAddressListDto implements IGetLocationAddressListDto {
    address: string | undefined;

    constructor(data?: IGetLocationAddressListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data['address'];
        }
    }

    static fromJS(data: any): GetLocationAddressListDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetLocationAddressListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['address'] = this.address;
        return data;
    }

    clone(): GetLocationAddressListDto {
        const json = this.toJSON();
        let result = new GetLocationAddressListDto();
        result.init(json);
        return result;
    }
}

export interface IGetLocationAddressListDto {
    address: string | undefined;
}

export class GetLocationDetailsTileDataOutput implements IGetLocationDetailsTileDataOutput {
    activeOrders: number;
    pendingOrders: number;

    constructor(data?: IGetLocationDetailsTileDataOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activeOrders = _data['activeOrders'];
            this.pendingOrders = _data['pendingOrders'];
        }
    }

    static fromJS(data: any): GetLocationDetailsTileDataOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLocationDetailsTileDataOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['activeOrders'] = this.activeOrders;
        data['pendingOrders'] = this.pendingOrders;
        return data;
    }

    clone(): GetLocationDetailsTileDataOutput {
        const json = this.toJSON();
        let result = new GetLocationDetailsTileDataOutput();
        result.init(json);
        return result;
    }
}

export interface IGetLocationDetailsTileDataOutput {
    activeOrders: number;
    pendingOrders: number;
}

export class GetLocationForEditOutput implements IGetLocationForEditOutput {
    location: CustomerLocationEditDto;
    customerName: string | undefined;

    constructor(data?: IGetLocationForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.location = _data['location'] ? CustomerLocationEditDto.fromJS(_data['location']) : <any>undefined;
            this.customerName = _data['customerName'];
        }
    }

    static fromJS(data: any): GetLocationForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLocationForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['location'] = this.location ? this.location.toJSON() : <any>undefined;
        data['customerName'] = this.customerName;
        return data;
    }

    clone(): GetLocationForEditOutput {
        const json = this.toJSON();
        let result = new GetLocationForEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetLocationForEditOutput {
    location: CustomerLocationEditDto;
    customerName: string | undefined;
}

export class GetStateListDto implements IGetStateListDto {
    state: string | undefined;
    id: number;

    constructor(data?: IGetStateListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data['state'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): GetStateListDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetStateListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['state'] = this.state;
        data['id'] = this.id;
        return data;
    }

    clone(): GetStateListDto {
        const json = this.toJSON();
        let result = new GetStateListDto();
        result.init(json);
        return result;
    }
}

export interface IGetStateListDto {
    state: string | undefined;
    id: number;
}

export class QuoteTabDetailsDto implements IQuoteTabDetailsDto {
    quoteId: number;
    quoteDetailId: number;
    quoteNumber: string | undefined;
    customerLocationId: number;
    locationName: string | undefined;
    productId: number;
    productName: string | undefined;
    requestForService: moment.Moment | undefined;
    partnerName: string | undefined;
    pm: UserListDto[] | undefined;
    spm: UserListDto[] | undefined;

    constructor(data?: IQuoteTabDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quoteId = _data['quoteId'];
            this.quoteDetailId = _data['quoteDetailId'];
            this.quoteNumber = _data['quoteNumber'];
            this.customerLocationId = _data['customerLocationId'];
            this.locationName = _data['locationName'];
            this.productId = _data['productId'];
            this.productName = _data['productName'];
            this.requestForService = _data['requestForService'] ? moment(_data['requestForService'].toString()) : <any>undefined;
            this.partnerName = _data['partnerName'];
            if (Array.isArray(_data['pm'])) {
                this.pm = [] as any;
                for (let item of _data['pm']) this.pm.push(UserListDto.fromJS(item));
            }
            if (Array.isArray(_data['spm'])) {
                this.spm = [] as any;
                for (let item of _data['spm']) this.spm.push(UserListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QuoteTabDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteTabDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['quoteId'] = this.quoteId;
        data['quoteDetailId'] = this.quoteDetailId;
        data['quoteNumber'] = this.quoteNumber;
        data['customerLocationId'] = this.customerLocationId;
        data['locationName'] = this.locationName;
        data['productId'] = this.productId;
        data['productName'] = this.productName;
        data['requestForService'] = this.requestForService ? this.requestForService.toISOString() : <any>undefined;
        data['partnerName'] = this.partnerName;
        if (Array.isArray(this.pm)) {
            data['pm'] = [];
            for (let item of this.pm) data['pm'].push(item.toJSON());
        }
        if (Array.isArray(this.spm)) {
            data['spm'] = [];
            for (let item of this.spm) data['spm'].push(item.toJSON());
        }
        return data;
    }

    clone(): QuoteTabDetailsDto {
        const json = this.toJSON();
        let result = new QuoteTabDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IQuoteTabDetailsDto {
    quoteId: number;
    quoteDetailId: number;
    quoteNumber: string | undefined;
    customerLocationId: number;
    locationName: string | undefined;
    productId: number;
    productName: string | undefined;
    requestForService: moment.Moment | undefined;
    partnerName: string | undefined;
    pm: UserListDto[] | undefined;
    spm: UserListDto[] | undefined;
}

export class QuoteTabDetailsDtoPagedResultDto implements IQuoteTabDetailsDtoPagedResultDto {
    totalCount: number;
    items: QuoteTabDetailsDto[] | undefined;

    constructor(data?: IQuoteTabDetailsDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data['totalCount'];
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(QuoteTabDetailsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QuoteTabDetailsDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteTabDetailsDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['totalCount'] = this.totalCount;
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }

    clone(): QuoteTabDetailsDtoPagedResultDto {
        const json = this.toJSON();
        let result = new QuoteTabDetailsDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IQuoteTabDetailsDtoPagedResultDto {
    totalCount: number;
    items: QuoteTabDetailsDto[] | undefined;
}

export interface IUploadFileInput {
    fileName: string;
    customerId: number;
}
